// extracted by mini-css-extract-plugin
module.exports = {"userButton":"UserIcon_userButton__kFnIs","dropDown":"UserIcon_dropDown__YHfjy"};